// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import { BootstrapBadge, BootstrapLink } from '../../../dsl/front';
import { ListWithAddonsMixin } from '../ui/ListWithAddonsMixin';
import { PublicationDate } from '../PublicationDate';
import { ReadMoreLink } from '../ReadMoreLink';
import { ReadingTime } from '../ReadingTime';
import { TextListItem } from '../TextListItem/TextListItem';
/**
 * TextList component with support for addons mixed within the list
 */
let TextListWithAddons = class TextListWithAddons extends ListWithAddonsMixin {
    get showBadge() {
        if (!this.listConfig) {
            return false;
        }
        if (typeof this.listConfig.showArticleTags === 'undefined') {
            return false;
        }
        return this.listConfig.showArticleTags;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], TextListWithAddons.prototype, "withoutBadge", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextListWithAddons.prototype, "showPublicationDate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextListWithAddons.prototype, "showReadingTime", void 0);
__decorate([
    Prop({ type: Object, required: true })
], TextListWithAddons.prototype, "windowService", void 0);
__decorate([
    Prop({ type: Object, required: true })
], TextListWithAddons.prototype, "tile", void 0);
TextListWithAddons = __decorate([
    Component({
        name: 'TextListWithAddons',
        components: { BootstrapBadge, BootstrapLink, PublicationDate, ReadMoreLink, ReadingTime, TextListItem },
        template: `
    <div v-if="items && items.length" class="text-list">
    <div class="text-list__container" :class="{ '--with-read-more' : readMoreLink }">
      <!-- Mixed articles and addons list -->
      <ul class="text-list__list list-unstyled">
        <template v-for="item in items">
          <!-- Article item -->
          <TextListItem
            v-if="item.type === 'article'"
            v-bind="tile"
            :item="item"
            :list-config="listConfig"
            :showReadingTime="true"
          />
          <!-- Addon item -->
          <li v-else-if="item.type === 'addon'" :key="item.key" class="text-list__addon-item">
            <component :is="getAddonComponent(item.data)" v-bind="getAddonProps(item.data)" />
          </li>
        </template>
      </ul>
      <!-- END | Mixed articles and addons list -->
    </div>

    <!-- "Read more" button -->
    <div v-if="readMoreLink" class="text-list__read-more-link">
      <ReadMoreLink :link="readMoreLink" />
    </div>
    </div>
  `
    })
], TextListWithAddons);
export { TextListWithAddons };
